module.exports = __webpack_public_path__ + "static/Philippines-35e86fb59d7f9fd4bae24a45e094c088.jpg";